// removed by extract-text-webpack-plugin
module.exports = {"navigation":"styles__navigation__yOtgW","navigationActive":"styles__navigationActive__2x16s","navItem":"styles__navItem__1hP9M","activeNavItem":"styles__activeNavItem__1ba3h","parentNavItem":"styles__parentNavItem__1k2GF","subNavigation":"styles__subNavigation__3BilJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HeaderNavigation/styles.scss
// module id = 835
// module chunks = 0